/**
 * BST Manuals & Downloads — main tabs + optional sub-tabs
 */
(function () {
  'use strict';

  const ACTIVE = 'is-active';

  function activateMainTab(tabKey) {
    document.querySelectorAll('[data-bst-manuals-tab]').forEach((tab) => {
      const active = tab.dataset.bstManualsTab === tabKey;
      tab.classList.toggle(ACTIVE, active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.setAttribute('tabindex', active ? '0' : '-1');
    });

    document.querySelectorAll('[data-bst-manuals-panel]').forEach((panel) => {
      const active = panel.dataset.bstManualsPanel === tabKey;
      panel.classList.toggle(ACTIVE, active);
      panel.toggleAttribute('hidden', !active);
    });
  }

  function activateSubTab(panel, subTabKey) {
    panel.querySelectorAll('[data-bst-manuals-sub-tab]').forEach((tab) => {
      const active = tab.dataset.bstManualsSubTab === subTabKey;
      tab.classList.toggle(ACTIVE, active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.setAttribute('tabindex', active ? '0' : '-1');
    });

    panel.querySelectorAll('[data-bst-manuals-sub-panel]').forEach((subPanel) => {
      const active = subPanel.dataset.bstManualsSubPanel === subTabKey;
      subPanel.classList.toggle(ACTIVE, active);
      subPanel.toggleAttribute('hidden', !active);
    });
  }

  function bindSubTabs(panel) {
    const tabs = panel.querySelectorAll('[data-bst-manuals-sub-tab]');
    if (!tabs.length) return;

    const initial =
      panel.querySelector('[data-bst-manuals-sub-tab].is-active')?.dataset.bstManualsSubTab ||
      tabs[0].dataset.bstManualsSubTab;

    activateSubTab(panel, initial);

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activateSubTab(panel, tab.dataset.bstManualsSubTab));
    });
  }

  function init() {
    const header = document.querySelector('[data-bst-manuals-downloads]');
    if (!header) return;

    const tabs = Array.from(header.querySelectorAll('[data-bst-manuals-tab]'));
    const panels = Array.from(document.querySelectorAll('[data-bst-manuals-panel]'));
    if (!tabs.length || !panels.length) return;

    const panelKeys = new Set(panels.map((panel) => panel.dataset.bstManualsPanel));
    const validTabs = tabs.filter((tab) => panelKeys.has(tab.dataset.bstManualsTab));

    const initial =
      validTabs.find((tab) => tab.classList.contains(ACTIVE))?.dataset.bstManualsTab ||
      validTabs[0]?.dataset.bstManualsTab ||
      panels.find((panel) => panel.classList.contains(ACTIVE))?.dataset.bstManualsPanel ||
      panels[0]?.dataset.bstManualsPanel;

    if (!initial) return;

    activateMainTab(initial);

    validTabs.forEach((tab) => {
      tab.addEventListener('click', () => activateMainTab(tab.dataset.bstManualsTab));
    });

    panels.forEach(bindSubTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
